import { match } from 'ts-pattern'
import i18next from 'i18next'
import type { EmploymentMutator } from '@/lib/entity/employment'
import type { Converter } from '@/lib/converter/entityFormatter'
import { layered } from '@/lib/layered'
import type { Kysely } from 'kysely'
import type { DB } from '@/lib/kysely-d'
import { asModifiedField } from '@/lib/converter/entityFormatter'

type EmploymentSchema = EmploymentMutator['merged']

export const EmploymentConverter: Converter<EmploymentSchema> = {
  icon: () => i18next.t('stages.icon.employment'),
  title: () => i18next.t('stages.table.employment'),
  subTitle: async (merged) => {
    const queryResult = await getUserNameQuery(merged.user_id!)
    const subTitle = queryResult.name
    return subTitle.merged() ?? subTitle.get('BASE') ?? ''
  },
  modifiedFields: (modified, column) => {
    const label = i18next.t(`stages.labels.employment.${column}`)
    return match(column)
      .with('partner_id', async () => {
        if (modified.partner_id === null) return asModifiedField(label, '自社')
        const queryResult = await getPartnerNameQuery(modified.partner_id!)
        return asModifiedField(label, queryResult.name.merged())
      })
      .with('cost', () =>
        asModifiedField(
          label,
          (modified.cost !== undefined ? modified.cost.toLocaleString() : '0') + ' 円'
        )
      )
      .with('start', 'type', (column) => {
        if (column === 'type') {
          return asModifiedField(label, i18next.t(`costPeriod.${modified[column]}`))
        }
        return asModifiedField(label, modified[column]!)
      })
      .with('id', 'user_id', () => undefined)
      .exhaustive()
  }
}

const getUserNameQuery = async (id: string) => {
  return await layered(async (db: Kysely<DB>) => {
    const result = await db
      .selectFrom('user')
      .select(['user.name'])
      .where('user.id', '=', id)
      .executeTakeFirst()
    if (!result) {
      return { name: null }
    }
    return result
  })
}

const getPartnerNameQuery = async (id: string) => {
  return await layered(async (db: Kysely<DB>) => {
    const result = await db
      .selectFrom('partner')
      .select(['partner.name'])
      .where('id', '=', id)
      .executeTakeFirst()
    if (!result) {
      return { name: null }
    }
    return result
  })
}
